import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import Loader from '../../general/Loader';
import { request } from '../../../utils/request';
import { formatCurrency } from '../../../utils/helpers';
import { auth } from '../../../utils/auth';

const GastosVehiculo = () => {
    const { id } = useParams();
    const [vehiculo, setVehiculo] = useState({});
    const [gastos, setGastos] = useState([]);
    const [loading, setLoading] = useState(true);
    const filtersQuery = window.location.search;
    const user = auth.getUser();
    const sucursal = user.sucursales.filter(
        (suc) => suc.id === user.sucursalActual
    )[0];

    const getGastos = async (url = null) => {
        url = url ? url : `gastos-internos?limit=50000&vehiculo=${id}`;

        const gastos = await request(url);
        setGastos(gastos);
    };

    const getVehiculo = async (url = null) => {
        url = url ? url : "vehiculos/" + id;
        const vehiculo = await request(url);

        setVehiculo(vehiculo.data);
    };

    useEffect(() => {
        setLoading(true);

        Promise.all([
            getGastos(`gastos-internos${filtersQuery}${filtersQuery ? '&' : '?'}limit=5000&vehiculo=${id}`),
            getVehiculo(),
        ]).then(() => setLoading(false));
    }, []);

    if(loading) {
        return <Loader />;
    }

    return <>
        <div className="row">
            <h2 className="col-md-12 text-center m-b-5">
                Historial de Gastos Realizados
            </h2>
            <div className="col-md-12 text-center">
                {sucursal.nombre} - {sucursal.direccion} •{" "}
                {new Date().toLocaleString()}
            </div>
            <div className="col-md-12 text-center p-b-10">
                <strong>FICHA: </strong> {vehiculo.ficha} |&nbsp;
                <strong>MARCA/MODELO: </strong> {vehiculo.modelo} |&nbsp;
                <strong>PLACA: </strong> {vehiculo.placa} |&nbsp;
                <strong>AÑO: </strong> {vehiculo.ano} |&nbsp;
                <strong>CHASIS: </strong> {vehiculo.chasis}
            </div>
        </div>

        <table className='table tickets-table'>
            <thead>
                <tr>
                    <th colSpan={4} className="text-right">Total</th>
                    <th className='text-right'><span style={{fontSize: '16px'}}>{formatCurrency(gastos.data.reduce((acc, gasto) => acc + parseFloat(gasto.total), 0))}</span></th>
                </tr>
                <tr>
                    <th>Fecha</th>
                    <th>Descripción</th>
                    <th>Categoría</th>
                    <th className='text-right'>Cantidad</th>
                    <th className='text-right'>Total</th>
                </tr>
            </thead>
            <tbody>
                {gastos.data.map((gasto) => {
                    const unidades = gasto.items?.reduce((acc, item) => {
                        const key = item.item?.unidad?.toUpperCase() || '';

                        if (!Object.hasOwn(acc, key)) {
                            acc[key] = 0;
                        }

                        acc[key] += parseFloat(item.cantidad);

                        return acc;
                    }, {});
                    const cantidades = Object.entries(unidades || {}).map(([unidad, cantidad]) => `${cantidad} ${unidad}`.trim()).join(', ');

                    return <tr key={gasto.id}>
                        <td>{gasto.fecha}</td>
                        <td>
                            {gasto.suplidor?.nombre}
                            {gasto.items.map(item => (<div>
                                <small>{item.descripcion} - {formatCurrency(item.total)}</small>
                            </div>))}
                        </td>
                        <td>{gasto.categorias.map((categoria) => categoria.nombre).join(', ') }</td>

                        <td className='text-right'>
                            {cantidades}
                        </td>
                        <td className='text-right'>
                            {formatCurrency(gasto.total)}
                        </td>
                    </tr>;
                })}
            </tbody>
            <tfoot>
                <tr>
                    <th colSpan={4} className="text-right">Total</th>
                    <th className='text-right'><span style={{fontSize: '16px'}}>{formatCurrency(gastos.data.reduce((acc, gasto) => acc + parseFloat(gasto.total), 0))}</span></th>
                </tr>
            </tfoot>
        </table>
    </>;
};

export default GastosVehiculo;
